module.exports = __webpack_public_path__ + "fonts/opensans-regular.9015e788.woff2";